<script setup>
import EmailIcon from "@/components/About/EmailIcon.vue";
</script>

<template>
  <h1 class="heading1">
    Submit an accord
    <hr class="gradientLine" />
  </h1>

  <h2 class="pb-8 text-justify">
    Download our step-by-step guide and use the provided one-slide template to showcase institution's achievements.
    To submit your accord, please forward the one slide-template to
    <a
      href="mailto: eqrc@mgmt.au.dk"
      class="gradientText hoverUnderline cursor-pointer relative mr-7"
    >
      eqrc@mgmt.au.dk
      <EmailIcon email="mailto: eqrc@mgmt.au.dk" class="absolute -bottom-0.5" />
    </a>
    . Once we have received it, we will upload it to our system.
  </h2>

  <section class="grid k1:grid-cols-2 grid-cols-1 k1:gap-12 gap-6">
    <div>
      <img class="object-contain k1:h-64" src="/Principles_svg.svg" alt="" />
      <div>
        <p class="gradientText hoverUnderline cursor-pointer mt-8">
          <a href="eduAccord.pdf">Download the Step-by-Step Guide for educational institutions</a>
        </p>
        <p class="gradientText hoverUnderline cursor-pointer">
          <a href="eduAccordTemplate.docx">Access the One-Slide Template</a>
        </p>
      </div>
    </div>
  </section>
  <div class="mt-8">
    All accepted submissions will be displayed publicly on
    <a href="https://quantumready.eu/#/" class="gradientText hoverUnderline">
      QuantumReady.eu
    </a>
    and the submitting organisations will be allowed to incorporate the official
    EQRC Accords symbol on their organisation website.
  </div>
</template>

<style scoped></style>
